<template>
    <div class="row">
        <div class="col-sm">
            <div class="card-body">
                <form class="default-form" @submit="createBlogSubmit" novalidate>
                    <div class="form-group">
                        <label for="titleInput">Naslov</label>
                        <input id="titleInput" class="form-control" type="text" placeholder="Naslov" v-model="title"/>
                    </div>
                    <Editor/>
<!--                    <div class="form-group">-->
<!--                        <div class="form-check">-->
<!--                            <input class="form-check-input" type="checkbox" id="availableInput" v-model="visible">-->
<!--                            <label class="form-check-label" for="availableInput">Vidljiv</label>-->
<!--                        </div>-->
<!--                    </div>-->
                    <button type="submit" class="btn btn-primary">Napravi</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions} from "vuex";

import Editor from "@/component/common/editor/Editor.vue";

export default {
    name: "AdminCreateBlog",
    components: {
        Editor,
    },
    data() {
        return {
            title: "",
            editor: null,
            visible: true
        }
    },
    // mounted() {
    //     this.editor = new Editor({
    //         content: '<p>Sadrzaj....</p>',
    //         extensions: [
    //             StarterKit,
    //         ],
    //     })
    // },
    //
    // beforeDestroy() {
    //     this.editor.destroy()
    // },
    methods: {
        ...mapActions([
            "saveBlog"
        ]),

        createBlogSubmit(e) {
            e.preventDefault()



            if (this.isFormValid()) {
                this.saveBlog({
                    title: this.title,
                    content: this.editor.getHTML(),
                    likeCount: 0,
                    viewCount: 0,
                    minutesToRead: 0,
                    visible: this.visible
                })
            }
        },

        isFormValid() {
            if (!this.title) {
                this.$notify({
                    group: 'errors',
                    title: 'Greska u pravljenju bloga',
                    text: 'Naslov ne moze da bude prazan!'
                })
                return false
            }

            return true
        },

        clearState() {
            this.title = ""
            this.content = ""
        }
    }
}
</script>

<style scoped>


.custom-textarea-style :focus-visible {
    outline: none !important;
}
</style>